import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams, IRowNode } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    @if (!!params?.data) {
      <div class="flex w-96">
        @if (params?.data?.is_connected) {
          <div class="flex justify-between">
            <div class="flex items-center whitespace-nowrap">
              <div class="mr-1 h-3 w-3 rounded-full bg-aux-green-dark"></div>
              <span class="text-aux-black">Connected</span>
            </div>
            @if (params?.data?.is_oauth) {
              <button
                class="aux-link ml-10 h-8 w-8 cursor-pointer"
                type="button"
                (click)="onLogOutClick()"
              >
                Logout
              </button>
            }
          </div>
        }
        @if (!params?.data?.is_connected) {
          <div class="flex justify-between">
            <div class="flex items-center whitespace-nowrap">
              <div class="mr-1 h-3 w-3 rounded-full bg-aux-red-dark"></div>
              <span class="text-aux-black">Not Connected</span>
            </div>
            @if (params?.data?.is_oauth) {
              <button
                class="btn--hyperlink ml-10 h-8 w-8 cursor-pointer"
                type="button"
                (click)="onLogInClick()"
              >
                Login
              </button>
            }
          </div>
        }
      </div>
    }
  `,
})
export class AgIntegrationsConnectComponent implements ICellRendererAngularComp {
  params?: ICellRendererParams & {
    hideButtons?: boolean;
    logInClickFN: ((params: { rowNode: IRowNode }) => void) | undefined;
    logOutClickFN: ((params: { rowNode: IRowNode }) => void) | undefined;
  };

  agInit(
    params: ICellRendererParams & {
      logInClickFN: (() => void) | undefined;
      logOutClickFN: (() => void) | undefined;
    }
  ) {
    this.params = params;
  }

  onLogInClick() {
    if (this.params?.logInClickFN) {
      this.params.logInClickFN({ rowNode: this.params.node });
    }
  }

  onLogOutClick() {
    if (this.params?.logOutClickFN) {
      this.params.logOutClickFN({ rowNode: this.params.node });
    }
  }

  refresh(): boolean {
    return false;
  }
}
